import React, {useEffect, useState} from "react"
import Time from "../lib/Time"
import styles from '../styles/OrganizationReports.module.css'
import {Spinner} from "react-bootstrap"
import {Organization} from "../Resources"

const OrganizationsDeviceActivityReport = () => {
  const [organizations, setOrganizations] = useState([])
  const [loading, setLoading] = useState(false)
  const [reportsLoaded, setReportsLoaded] = useState(0)

  useEffect(() => {
    setLoading(true)
    Organization.where({ root: true }).page(1).perPage(1000).all().then((collection) => {
      setOrganizations(collection.toArray())
    })
  }, [])

  useEffect(() => {
    const loadReports = async (organizations) => {
      for (const organization of organizations) {
        await organization.loadDeviceActivityReport()
        setReportsLoaded(amount => amount + 1)
      }
      setLoading(false)
    }
    void loadReports(organizations)
  }, [organizations])


  const parseDate = (date) => {
    const year = date.substring(0, 4)
    const month = date.substring(4)
    return new Date(year, month, 0)
  }

  // Return months of the last full quarter
  const months = () => {
    const month = new Date().getMonth() + 1
    if (month > 3 & month < 7) {
      return [1, 2, 3]
    } else if (month > 6 && month < 10) {
      return [4, 5, 6]
    } else if (month > 9 && month <= 12) {
      return [7, 8, 9]
    } else {
      return [10, 11, 12]
    }
  }

  const price = (amount) => {
    return Math.ceil( amount * Math.max(2.5, 5 - amount * 0.005))
  }

  const formatPrice = (price) => {
    return (Math.floor(price * 100) / 100).toFixed(2)
  }

  const deviceActivityHeader = () => {
    const report = organizations.length > 0 ? organizations[0].deviceActivityReport() : null
    if (!report) {
      return []
    }
    const data = Object.entries(report.report).filter(item => {
      const month = item[0].substring(4)
      return months().includes(parseInt(month, 10))
    }).sort((a, b) => (
      parseDate(a[0]).getTime() - parseDate(b[0]).getTime()
    ))
    return data.map(item => item[0]).flat()
  }

  const deviceActivityReportItems = (organization) => {
    const report = organization.deviceActivityReport()
    if (!report) {
      return []
    }
    const data = Object.entries(report.report).filter(item => {
      const month = item[0].substring(4)
      return months().includes(parseInt(month, 10))
    }).sort((a, b) => (
      parseDate(a[0]).getTime() - parseDate(b[0]).getTime()
    ))
    // const totalDevices = data.reduce((sum, [_date, values]) => sum + values[0], 0)
    const totalPrice = data.reduce((sum, [_date, values]) => sum + price(values[0]), 0)
    const totalSMS = data.reduce((sum, [_date, values]) => sum + values[1], 0)
    // SMS price is 0.2 EUR per SMS, 10 SMS per device per month are free
    const totalSMSToBeBilled = data.reduce((sum, [_date, values]) => sum + Math.max(0, values[1] - values[0] * 10), 0)
    const totalSMSPrice = totalSMSToBeBilled * 0.2
    return [
      ...data.map(item => item[1]).flat(),
      <strong>{`${formatPrice(totalPrice)} €`}</strong>,
      totalSMS > 0 ? `${formatPrice(totalSMSPrice)} € (${totalSMS} pcs)` : '-'
    ]
  }

  return (
    <div>
      <h5>Device activity report</h5>
      <table className='table table-striped table-bordered table-hover'>
        <tbody>
          <tr>
            <th>Organization</th>
            {deviceActivityHeader().map(date => (
              <th key={date} colSpan={2}>
                <Time timeFormat={null} dateFormat="months">{parseDate(date)}</Time>
              </th>
            ))}
            <th colSpan={2}>
              Totals
            </th>
          </tr>
          <tr>
            <th></th>
            {deviceActivityHeader().map(_date => (<>
              <th>Devices</th>
              <th>SMS</th>
            </>))}
            <th>Devices</th>
            <th>SMS</th>
          </tr>
          {organizations.filter(org => org.deviceActivityReport()).map(org =>
            <tr key={org.id}>
              <td>{org.name}</td>
              {deviceActivityReportItems(org).map((value, _index) => (
                <td>{value}</td>
              ))}
            </tr>
          )}
        </tbody>
      </table>
      {loading &&
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>}
    </div>
  )
}

export default OrganizationsDeviceActivityReport
